// BraveAim - Main JavaScript

// Aguarda o carregamento completo do DOM
document.addEventListener('DOMContentLoaded', function() {

    // Inicializa os componentes
    initMobileMenu();
    initDropdown();
    initProductPageVideo();
    initScrollAnimations();
    initAutoplayVideoManager();

});

/**
 * Inicializa animações ao scroll (Intersection Observer)
 */
function initScrollAnimations() {
    const communitySection = document.querySelector('.community-container');

    if (!communitySection) return;

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    observer.observe(communitySection);
}

/**
 * Inicializa o menu mobile sidebar
 */
function initMobileMenu() {
    const mobileMenuBtn = document.getElementById('mobileMenuBtn');
    const mainNav = document.getElementById('mainNav');
    const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');

    if (!mobileMenuBtn || !mainNav) return;

    // Toggle menu ao clicar no botão hamburger
    mobileMenuBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        mainNav.classList.toggle('active');
        if (mobileMenuOverlay) {
            mobileMenuOverlay.classList.toggle('active');
        }
        document.body.style.overflow = mainNav.classList.contains('active') ? 'hidden' : '';
    });

    // Fecha menu ao clicar no overlay
    if (mobileMenuOverlay) {
        mobileMenuOverlay.addEventListener('click', function() {
            mainNav.classList.remove('active');
            mobileMenuOverlay.classList.remove('active');
            document.body.style.overflow = '';
        });
    }

    // Fecha menu ao clicar em um link
    const navLinks = mainNav.querySelectorAll('.nav-link:not(.dropdown-toggle)');
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            mainNav.classList.remove('active');
            if (mobileMenuOverlay) {
                mobileMenuOverlay.classList.remove('active');
            }
            document.body.style.overflow = '';
        });
    });

    // Fecha menu ao pressionar ESC
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mainNav.classList.contains('active')) {
            mainNav.classList.remove('active');
            if (mobileMenuOverlay) {
                mobileMenuOverlay.classList.remove('active');
            }
            document.body.style.overflow = '';
        }
    });

    // Fecha menu ao redimensionar para desktop
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768 && mainNav.classList.contains('active')) {
            mainNav.classList.remove('active');
            if (mobileMenuOverlay) {
                mobileMenuOverlay.classList.remove('active');
            }
            document.body.style.overflow = '';
        }
    });
}

/**
 * Inicializa o comportamento do dropdown do menu
 */
function initDropdown() {
    const dropdown = document.querySelector('.dropdown');
    const dropdownToggle = dropdown?.querySelector('.dropdown-toggle');
    const dropdownMenu = dropdown?.querySelector('.dropdown-menu');

    if (!dropdown || !dropdownToggle || !dropdownMenu) return;

    // Toggle dropdown ao clicar
    dropdownToggle.addEventListener('click', function(e) {
        e.preventDefault();

        // Adiciona/remove classe active
        dropdown.classList.toggle('active');
    });

    // Fecha dropdown ao clicar fora
    document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target)) {
            dropdown.classList.remove('active');
        }
    });

    // Fecha dropdown ao pressionar ESC
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            dropdown.classList.remove('active');
        }
    });
}

/* initDiscordButton removed 2026-07-14 — the .btn-discord buttons are now
   real Sign in / My Library links (see header sign-in block). The old handler
   preventDefault()'d the FIRST .btn-discord on the page, which is the MOBILE
   menu button, so tapping Sign in on mobile did nothing while desktop worked. */

/**
 * Adiciona indicador de scroll no header
 */
(function() {
    const header = document.querySelector('.header');
    if (!header) return;
    let wasScrolled = false;
    window.addEventListener('scroll', function() {
        const scrolled = window.scrollY > 50;
        if (scrolled === wasScrolled) return;
        wasScrolled = scrolled;
        header.classList.toggle('scrolled', scrolled);
    }, { passive: true });
})();

/**
 * Marca o link ativo baseado na página atual
 */
function setActiveLink() {
    const currentPage = window.location.pathname.split('/').pop() || 'main.html';
    const navLinks = document.querySelectorAll('.nav-link');

    navLinks.forEach(link => {
        const href = link.getAttribute('href');

        // '#' links (dropdown toggles) are never "the current page".
        if (href && href !== '#' && href === currentPage) {
            link.classList.add('active');
        } else {
            link.classList.remove('active');
        }
    });
}

// Executa ao carregar
setActiveLink();













/* Product "Find More" click handling removed 2026-08-14 — navigation lives in
   custom-home.liquid's navOnClick, which this handler only fought (it toggled an
   'active' expansion state whose card CSS targets nothing in the markup, and its
   data-url branch waited 7 seconds before redirecting an attribute nothing sets). */

/**
 * FAQ Accordion Functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    if (!question) return;

    question.addEventListener('click', function() {
      // Toggle current item
      const isActive = item.classList.contains('active');

      // Close all items
      faqItems.forEach(otherItem => {
        otherItem.classList.remove('active');
        const q = otherItem.querySelector('.faq-question');
        if (q) q.setAttribute('aria-expanded', 'false');
      });

      // Open clicked item if it wasn't active
      if (!isActive) {
        item.classList.add('active');
        question.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

/**
 * Product Details Dropdown Functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  const detailDropdowns = document.querySelectorAll('.detail-dropdown');

  detailDropdowns.forEach(dropdown => {
    const header = dropdown.querySelector('.detail-dropdown-header');
    if (!header) return;

    header.addEventListener('click', function() {
      // Toggle current dropdown
      dropdown.classList.toggle('active');
    });
  });
});



/* initProductVideos removed 2026-08-14 — the IntersectionObserver in
   custom-home.liquid is the sole .container-video controller. The legacy
   hover/checkpoint body (with its 73-second lock tied to one specific clip)
   was dead code shipped on every page. */



/**
 * Product Page Video Click Functionality
 */
function initProductPageVideo() {
  const productVideo = document.querySelector('.product-main-image');

  if (!productVideo || productVideo.tagName !== 'VIDEO') return;

  let isPlaying = true; // Começa playing pois tem autoplay
  let isReversing = false;
  let reverseInterval = null;

  productVideo.addEventListener('click', function() {
    // Cancela qualquer reversão em andamento
    if (reverseInterval) {
      clearInterval(reverseInterval);
      reverseInterval = null;
    }

    if (!isPlaying) {
      // Ativa o vídeo
      isPlaying = true;
      isReversing = false;
      productVideo.play().catch(function() {});
    } else {
      // Desativa o vídeo (a reversão animada chamava reverseVideo(),
      // que não existe em lugar nenhum — clicar lançava ReferenceError
      // e o vídeo nunca pausava)
      isPlaying = false;
      isReversing = false;
      productVideo.pause();
    }
  });

  productVideo.addEventListener('ended', function() {
    isPlaying = false;
    productVideo.pause();
  });
}

/**
 * Video Comparison Slider Functionality (suporta múltiplos sliders)
 */
function initComparisonSlider() {
  const sliders = document.querySelectorAll('.comparison-slider');
  if (!sliders.length) return;

  sliders.forEach(slider => {
    const afterLayer = slider.querySelector('.comparison-after');
    const handle = slider.querySelector('.comparison-handle');
    let isDragging = false;

    function updateSliderPosition(clientX) {
      const rect = slider.getBoundingClientRect();
      let position = (clientX - rect.left) / rect.width;
      position = Math.max(0.05, Math.min(0.95, position));
      const percentage = position * 100;
      afterLayer.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
      handle.style.left = `${percentage}%`;
    }

    function startDrag(e) {
      isDragging = true;
      slider.classList.add('dragging');
      e.preventDefault();
    }

    function stopDrag() {
      if (isDragging) {
        isDragging = false;
        slider.classList.remove('dragging');
      }
    }

    function onDrag(e) {
      if (!isDragging) return;
      let clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      updateSliderPosition(clientX);
    }

    // Mouse events
    slider.addEventListener('mousedown', function(e) {
      startDrag(e);
      updateSliderPosition(e.clientX);
    });

    slider.addEventListener('mousemove', onDrag);
    slider.addEventListener('mouseleave', stopDrag);
    document.addEventListener('mouseup', stopDrag);

    // Touch events
    slider.addEventListener('touchstart', function(e) {
      startDrag(e);
      updateSliderPosition(e.touches[0].clientX);
    }, { passive: false });

    slider.addEventListener('touchmove', function(e) {
      if (isDragging) {
        e.preventDefault();
        onDrag(e);
      }
    }, { passive: false });

    slider.addEventListener('touchend', stopDrag);

    // Sincroniza os vídeos
    const videos = slider.querySelectorAll('.comparison-video');
    videos.forEach(video => {
      video.addEventListener('loadeddata', function() {
        video.currentTime = 0;
      });
    });
  });
}

// Inicializa o comparison slider quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', initComparisonSlider);

// Inicializa enhancements quando o DOM estiver pronto

// Inicializa Unreal Comparison Tabs quando o DOM estiver pronto

// Inicializa Unreal Enhancements quando o DOM estiver pronto

// Inicializa Motion Sections quando o DOM estiver pronto


/**
 * Purchase Button - Adiciona ao carrinho e vai para /cart
 */
/* Purchase handling removed 2026-08-14: each product section owns its
   capture-phase handler with variant resolution and error surfacing; this
   duplicate added first-variant-to-cart with no response.ok check. */

/**
 * Pausa vídeos autoplay fora da viewport (páginas de produto têm ~10 deles).
 * O hero da homepage, os cards e o vídeo do optimizer têm controladores
 * próprios e ficam de fora.
 */
function initAutoplayVideoManager() {
  if (!('IntersectionObserver' in window)) return;
  const managed = [...document.querySelectorAll('video[autoplay]')].filter(function(v) {
    return !v.closest('[data-hero-placeholder-media]') &&
           !v.classList.contains('container-video') &&
           v.id !== 'wootilityVideo';
  });
  if (!managed.length) return;
  // Estado inicial: os clips empilhados não-ativos autoplay do markup;
  // pará-los já poupa a descodificação invisível.
  managed.forEach(function(v) {
    const item = v.closest('.enhancement-video-item');
    if (item && !item.classList.contains('active')) v.pause();
  });
  const io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      const v = entry.target;
      // Vídeos empilhados a opacity:0 (enhancement stacks) são geridos
      // pelo switcher da própria secção; só tratamos visibilidade de scroll.
      if (entry.isIntersecting) {
        if (v.closest('.enhancement-video-item') && !v.closest('.enhancement-video-item').classList.contains('active')) return;
        v.play().catch(function() {});
      } else {
        v.pause();
      }
    });
  }, { rootMargin: '150px 0px' });
  managed.forEach(function(v) { io.observe(v); });
}
